// filepath: src/features/widgets/useChatBookingBadgeEvent.ts
import { useEffect } from 'react';
import { storage } from '../configuration/setup/storage';
import { sendWindowMessage } from '../services/sendWindowMessage';
import { useGetUpsellingBadgeSeenStorageKey } from './useGetUpsellingBadgeSeenStorageKey';
import { gaPush } from '../configuration/setup/googleAnalytics';
import { useGetUpsellingCampaign } from './useGetUpsellingCampaign';

export const useShowAdvertisementBadge = (chatActivation: boolean | undefined) => {
    const SEEN_KEY = useGetUpsellingBadgeSeenStorageKey();
    const upsellingCampaign = useGetUpsellingCampaign();

    useEffect(() => {
        const seen = storage.load(SEEN_KEY);
        if (seen || chatActivation === undefined) {
            return;
        }
        if (!chatActivation) {
            sendWindowMessage({
                type: 'EVENT_WIDGET_CHAT_TOTAL_UNREAD_MESSAGE_COUNT_CHANGED',
                payload: 1,
            });
            gaPush({
                category: upsellingCampaign.trackingCategory,
                action: 'Show upselling badge',
                label: 'Show order communication upselling advertisement badge',
            });
        }
    }, [chatActivation]);
};
